import React, { createContext, useContext } from "react";
import { useBalances } from "../shared/hooks/useBalances";

// Exported so consumers that must read the balance WITHOUT throwing when no
// provider is mounted (e.g. PlayModeProvider deriving its default, isolated
// component tests) can call useContext(BalanceContext) directly and guard for
// undefined. App code should still prefer useBalanceContext().
export const BalanceContext = createContext();

// Helper function to calculate redeemable Cluck Bucks
const calculateRedeemableBalance = (totalSwpBalance, playthroughRequired) => {
  return Math.max(0, totalSwpBalance - playthroughRequired);
};

export const BalanceProvider = ({ children }) => {
  // Single instance of useBalances hook
  const balanceData = useBalances();

  // Always provide safe defaults (feathers included for VIP status updates)
  const safeBalanceData = balanceData || {
    balances: { gold: 0, swp: 0, swpPlaythroughRequired: 0, feathers: 0 },
    loading: false,
    error: null,
  };

  // Enhance balance data with playthrough calculations
  const enhancedBalanceData = {
    ...safeBalanceData,
    balances: {
      ...safeBalanceData.balances,
      // Add redeemable amount for Cluck Bucks only
      swpRedeemable: calculateRedeemableBalance(
        safeBalanceData.balances?.swp || 0,
        safeBalanceData.balances?.swpPlaythroughRequired || 0,
      ),
    },
  };

  return (
    <BalanceContext.Provider value={enhancedBalanceData}>
      {children}
    </BalanceContext.Provider>
  );
};

export const useBalanceContext = () => {
  const context = useContext(BalanceContext);
  if (!context) {
    throw new Error("useBalanceContext must be used within a BalanceProvider");
  }
  return context;
};
